/* Polsk katalog for locale-purchases-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'buy.remove': 'Usuń',
  'buy.openPreview': 'Otwórz podgląd',
  'buy.noPreview': 'Brak podglądu',
  'buy.savedInBackend': 'Dokument został zapisany.',
  'buy.open': 'Otwórz',
  'buy.addMoreDocs': 'Dodaj więcej dokumentów',
  'buy.addMoreDocsHelp': 'Dołącz kolejne paragony lub strony do tego samego zakupu. Wszystkie dołączone dokumenty są wymienione tutaj.',
  'buy.uploadDoc': 'Prześlij dokument',
  'buy.uploadDocHelp': 'Dołącz paragon lub fakturę za zakup. Możesz przeciągnąć plik, wybrać go z komputera albo pobrać dokument ze skrzynki odbiorczej.',
  'buy.dropOrPick': 'Upuść lub wybierz dokument',
  'buy.storedIn': 'PDF lub obraz jest zapisywany w Firebase/skrzynce odbiorczej.',
  'buy.fromInbox': 'Pobierz ze skrzynki odbiorczej',
  'buy.attachments': 'Załączniki',
  'buy.pickFiles': 'Wybierz pliki',
  'buy.dropAttachments': 'Upuść załączniki tutaj',
  'buy.attachmentsNote': 'Załączniki są przesyłane na serwer przy zapisywaniu księgowania.',
  'buy.supplierSearch': 'Szukaj lub dodaj dostawcę...',
  'buy.supplierSearchShort': 'Szukaj lub dodaj dostawcę',
  'buy.supplierClose': 'Zamknij wybór dostawcy',
  'buy.supplierNone': 'Nie znaleziono dostawców.',
  'buy.supplierNew': 'Nowy dostawca',
  'buy.name': 'Nazwa',
  'buy.org': 'Nr org.',
  'buy.email': 'E-mail',
  'buy.phone': 'Telefon',
  'buy.accountClose': 'Zamknij wybór konta',
  'buy.searchShort': 'Szukaj ...',
  'buy.noAccountMatch': 'Żadne konto nie pasuje do wyszukiwania.',
  'buy.fromInboxRead': 'Pobrano ze skrzynki odbiorczej - SuperPlumma odczytała, co się dało.',
  'buy.docHelp': 'Dokument to paragon lub faktura potwierdzająca zakup. Przeciągnij obraz lub PDF - albo dotknij, aby wybrać plik. SuperPlumma odczyta datę, kwotę, dostawcę i VAT oraz zaproponuje sposób zaksięgowania zakupu.',
  'buy.dropReceipt': 'Upuść paragon tutaj',
  'buy.dropReceiptHelp': 'Pobierz dokument ze swoich plików lub wybierz „Pobierz ze skrzynki odbiorczej”, aby użyć dokumentu, który już przyszedł e-mailem. SuperPlumma automatycznie odczyta treść.',
  'buy.upload': 'Prześlij',
  'buy.type': 'Rodzaj zakupu',
  'buy.typeHelp': 'Wybierz, jak zarejestrować zakup. „Opłacony zakup” to zakup, który został już zapłacony. „Faktura dostawcy” służy, gdy faktura zostanie zapłacona później lub jest częściowo opłacona (staje się zobowiązaniem wobec dostawcy). „Szkice” pokazuje rozpoczęte zakupy, których jeszcze nie zaksięgowano.',
  'buy.description': 'Opis',
  'buy.descriptionPh': 'Np. subskrypcja lub podróż',
  'buy.toggleVat': 'Przełącz między netto a brutto',
  'buy.amountExInc': 'Kwota netto/brutto',
  'buy.amountExIncHelp': 'Dotknij, aby przełączyć, czy wpisujesz kwotę bez VAT (netto) czy z VAT (brutto). Plumme automatycznie przelicza między nimi. „Netto” to sam koszt, „brutto” to łączna kwota, którą zapłaciłeś.',
  'buy.vatRate': 'Stawka VAT',
  'buy.vatRateHelp': 'Stawka VAT zakupu. 25 % to stawka podstawowa, 15 % dotyczy żywności, 12 % m.in. transportu osób i noclegów, a 0 % stosuje się do zakupów zwolnionych. VAT od zakupu to VAT naliczony, który możesz odliczyć.',
  'buy.pickCategory': 'Konto/kategoria',
  'buy.category': 'Kategoria',
  'buy.categoryHelp': 'Jakiego rodzaju jest to koszt. Kategoria określa, na jakie konto zakup zostanie zaksięgowany, aby trafił poprawnie do rachunku zysków i strat oraz skattemelding.',
  'buy.supplier': 'Dostawca',
  'buy.accountFromHistory': 'Konto kosztowe zaproponowane na podstawie wcześniejszych zakupów u tego dostawcy. Możesz je zmienić w wierszu zakupu.',
  'buy.date': 'Data zakupu',
  'buy.invoiceNumber': 'Numer faktury',
  'buy.invoiceNumberPh': 'Np. 100245',
  'buy.dueDate': 'Termin płatności',
  'buy.lines': 'Wiersze',
  'buy.linesHelp': 'Każdy wiersz to jeden koszt z dokumentu, z własną kwotą, stawką VAT i kategorią. Jeśli paragon ma różne towary lub stawki VAT, utwórz jeden wiersz na każdy rodzaj. Możesz przeciągać wiersze, aby zmienić kolejność.',
  'buy.addLine': 'Dodaj wiersz',
  'buy.payment': 'Płatność',
  'buy.paymentHelp': 'Dla faktury dostawcy wybierz, czy faktura jest opłacona. Nieopłacone faktury są zapisywane jako otwarte zobowiązania wobec dostawców, aby płatność można było zarejestrować później.',
  'buy.immediatePaymentHelp': 'Zwykły zakup jest już opłacony. Wybierz konto, z którego zapłacono, i datę płatności.',
  'buy.paid': 'Opłacone',
  'buy.unpaid': 'Nieopłacone',
  'buy.paidFrom': 'Zapłacono z',
  'buy.choosePaymentSource': 'Wybierz źródło płatności',
  'buy.paidDate': 'Data płatności',
  'buy.paidDateHelp': 'Data zapłaty za zakup. Data zakupu określa okres księgowy i okres VAT samego zakupu.',
  'buy.dateLabel': 'Data',
  'buy.addPartPayment': 'Dodaj płatność częściową',
  'buy.addPartPaymentHelp': 'Zarejestruj kolejną płatność. Suma płatności częściowych jest odejmowana od całości - reszta jest pokazywana jako „pozostało”.',
  'buy.remaining': 'Pozostało',
  'buy.remainingHelp': 'Różnica między kwotą całkowitą a zarejestrowanymi płatnościami częściowymi. Jeśli wynosi 0, zakup jest w pełni rozliczony.',
  'buy.preview': 'Podgląd',
  'buy.previewHelp': 'Podgląd przesłanego dokumentu. Jeśli nie przesłałeś jeszcze dokumentu, możesz to zrobić tutaj.',
  'buy.dropReceiptLong': 'Upuść paragon tutaj - przeciągnij obraz lub PDF albo dotknij, aby wybrać plik.',
  'buy.summaryHelp': 'Podsumowanie pokazuje netto, VAT i łączną kwotę do zapłaty.',
  'buy.saveDraft': 'Zapisz szkic',
  'buy.saveDraftHelp': 'Zapisuje zakup jako szkic bez księgowania. Dokumenty i płatności nie zostaną oznaczone jako zaksięgowane, dopóki nie zakończysz zakupu.',
  'buy.title': 'Opłacony zakup',
  'buy.subtitle': 'Zarejestruj zakup - prześlij dokument, a resztę zaproponujemy.',
  'buy.drafts': 'Szkice',
  'buy.draftsSub': 'Rozpoczęte zakupy i aktywa, których jeszcze nie zaksięgowano',
  'buy.draftsSearchPh': 'Dostawca, opis, nr faktury lub kwota',
  'buy.showMore': 'Pokaż więcej',
  'buy.noDrafts': 'Brak szkiców',
  'buy.invoiceNoShort': 'Nr faktury',
  'buy.delete': 'Usuń',
  'buy.deleteDraftTitle': 'Usunąć szkic?',
  'buy.deleteDraftConfirm': 'Tak, usuń szkic',
  'buy.deleteDraftBody': 'Czy na pewno chcesz usunąć szkic dla',
  'buy.resetTitle': 'Wyczyść formularz i zacznij od nowa',
  'buy.reset': 'Wyczyść',
  'buy.howRegister': 'Jak chcesz zarejestrować zakup?',
  'buy.howRegisterSub': 'Najlepiej najpierw prześlij dokument - wtedy zaproponujemy resztę.',
  'buy.stepByStep': 'Krok po kroku',
  'buy.stepByStepHelp': 'Prowadzi przez zakup po jednej części - najpierw dokument, potem data, wiersze i płatność. Dobre, gdy chcesz działać spokojnie.',
  'buy.stepByStepShort': 'Najpierw dokument, potem data, wiersze i płatność.',
  'buy.onePage': 'Wszystko na jednej stronie',
  'buy.onePageHelp': 'Pokazuje cały formularz zakupu na jednej stronie. Dobre, gdy masz wprawę w rejestrowaniu zakupów i chcesz mieć wszystko przed sobą.',
  'buy.onePageShort': 'Cały formularz zakupu w jednym miejscu.',
  'buy.toSteps': 'Przełącz na krok po kroku',
  'buy.toOnePage': 'Przełącz na wszystko na jednej stronie',
  'buy.back': 'Wstecz',
  'buy.next': 'Dalej',
  'buy.backToVouchers': 'Wróć do transakcji',
  'buy.salesType': 'Rodzaj sprzedaży',
  'buy.paidTo': 'Zapłacono na',
  'buy.payOperating': 'Rachunek operacyjny',
  'buy.payCash': 'Gotówka',
  'buy.payPrivate': 'Prywatnie',
  'buy.whatSold': 'Co sprzedałeś?',
  'buy.amountExVat': 'Kwota netto',
  'buy.amountIncVat': 'Kwota z VAT',
  'buy.vatLabel': 'VAT',
  'buy.otherSale': 'Inna sprzedaż',
  'buy.invoiceOrQuote': 'Faktura / oferta',
  'buy.switchMode': 'Zmień tryb',
  'buy.moreOptions': 'Więcej opcji',
  'buy.postAs': 'Zaksięguj jako',
  'buy.backendUploadNotReady': 'Przesyłanie na serwer nie jest gotowe.',
  'buy.multipleUploadedShowFirst': 'Przesłano kilka dokumentów. Tutaj wyświetlany jest pierwszy.',
  'buy.uploadFailed': 'Nie udało się przesłać dokumentu.',
  'buy.dropReceiptTitle': 'Upuść paragon tutaj',
  'buy.dropReceiptSubtitle': '...a pomożemy Ci go prawidłowo przypisać. Przeciągnij obraz lub PDF albo kliknij, aby wybrać plik.',
  'buy.attachedCount': 'Powiązane dokumenty: {count}',
  'buy.uploading': 'Przesyłanie...',
  'buy.chooseFile': 'Wybierz plik',
  'buy.dropToUpload': 'Upuść dokument, aby go przesłać',
  'buy.accountFallbackOperating': 'Rachunek bieżący · 1920',
  'buy.accountFallbackCash': 'Gotówka',
  'buy.accountFallbackPrivate': 'Wydatek prywatny',
  'buy.accountFallbackCash1900': 'Gotówka - 1900',
  'buy.accountFallbackPrivate2060': 'Prywatne - 2060',
  'buy.addSupplierQuery': 'Dodaj „{query}”',
  'buy.chartNotConnected': 'Plan kont nie jest połączony z magazynem danych.',
  'buy.accountAdded': 'Konto zostało dodane.',
  'buy.accountSaveFailed': 'Nie udało się zapisać konta.',
  'buy.chooseAccount': 'Wybierz konto',
  'buy.forQuery': 'dla „{query}”',
  'buy.newCustomAccountTitle': 'Nowe konto niestandardowe',
  'buy.saving': 'Zapisywanie...',
  'buy.saveAccount': 'Zapisz konto',
  'buy.accountNamePlaceholder': 'Np. Tworzenie oprogramowania',
  'buy.accountHelperText': 'Konto stanie się dostępne w wyszukiwarce kont i zostanie zmapowane na konto standardowe na potrzeby raportowania i zamknięcia roku.',
  'buy.inventoryProduct': 'Towar magazynowy',
  'buy.notTracked': 'Bez ewidencji magazynowej',
  'buy.quantityInStock': 'Ilość przyjęta na magazyn',
  'buy.inStockCount': 'Na magazynie: {n}',
  'buy.inventoryLineToggle': 'Ewidencjonuj w magazynie',
  'buy.inventoryLineToggleHelp': 'Włącz, gdy zakup ma zwiększyć stan zarejestrowanego towaru magazynowego.',
  'buy.inventorySearchPlaceholder': 'Wybierz towar magazynowy',
  'buy.inventorySearch': 'Szukaj według nazwy, numeru towaru, SKU lub EAN',
  'buy.inventorySearchEmpty': 'Żaden towar magazynowy nie pasuje do wyszukiwania.',
  'buy.inventoryOpenProducts': 'Otwórz produkty',
  'buy.inventoryUnitsInStock': 'na magazynie',
  'inventoryPurchase.settingsTitle': 'Ewidencja magazynowa przy zakupach',
  'inventoryPurchase.settingsHelp': 'Pokaż opcjonalne pole magazynowe w pozycjach zakupu, aby zakup mógł zwiększyć stan zarejestrowanego towaru magazynowego.',
  'inventoryPurchase.offHelp': 'Pole magazynowe jest ukryte w nowych zakupach. Produkty i wcześniejsze ruchy magazynowe zostają zachowane.',
  'inventoryPurchase.migratedTitle': 'Ewidencja magazynowa przy zakupach jest włączona',
  'inventoryPurchase.migratedText': 'Firma ma już produkty z automatyczną ewidencją magazynową. Dlatego powiązanie z magazynem w pozycjach zakupu zostało włączone, aby dotychczasowy sposób pracy działał dalej.',
  'inventoryPurchase.acknowledge': 'Rozumiem',
  'inventoryPurchase.acknowledgeError': 'Nie udało się zapisać potwierdzenia.',
  'inventoryPurchase.openSettings': 'Otwórz ustawienia',
  'inventoryPurchase.disableTitle': 'Wyłączyć ewidencję magazynową przy zakupach?',
  'inventoryPurchase.disableConfirm': 'Wyłącz',
  'inventoryPurchase.disableWarning': 'Pole magazynowe zostanie ukryte w nowych zakupach. Zakupów nie będzie można wtedy powiązać z produktami magazynowymi, a stan może stać się nieprawidłowy, jeśli nie zostanie ręcznie sprawdzony i skorygowany.',
  'inventoryPurchase.disableHistory': 'Istniejące produkty i historyczne ruchy magazynowe nie zostaną usunięte. Policz magazyn i ręcznie zarejestruj potrzebne korekty.',
  'inventoryPurchase.enabledLabel': 'Ewidencja magazynowa przy zakupach',
  'inventoryPurchase.disabledLabel': 'Ewidencja magazynowa przy zakupach',
  'buy.noDescription': 'Bez opisu',
  'buy.attachmentFallback': 'Dokument',
  'buy.lockVatTitle': 'Okres VAT został rozliczony',
  'buy.lockYearTitle': 'Rok obrotowy jest zamknięty',
  'buy.lockBankTitle': 'Okres bankowy jest uzgodniony',
  'buy.lockVatTarget': 'okres VAT',
  'buy.lockYearTarget': 'zamknięcie roku',
  'buy.lockBankTarget': 'uzgodnienie bankowe',
  'buy.lockWarningText': '{title}. Nadal możesz zmienić opis i konto kosztowe/kategorię zakupu, ale data zakupu, kwota, kod VAT i pola płatności są zablokowane. Otwórz lub skoryguj {target}, jeśli musisz zmienić te pola.',
  'buy.lockVatWarningText': '{title}. Data zakupu, kwota i kod VAT są zablokowane, ale opis, konto kosztowe/kategorię i konto płatności nadal można skorygować. Otwórz lub skoryguj {target}, jeśli podstawa VAT musi się zmienić.',
  'buy.backendSaveNotReady': 'Zapisywanie na serwerze nie jest gotowe.',
  'buy.needAtLeastOneLine': 'Dodaj co najmniej jedną pozycję zakupu.',
  'buy.needDescriptionAllLines': 'Wpisz opis we wszystkich pozycjach przed zaksięgowaniem.',
  'buy.needContentForDraft': 'Dodaj pozycję, dostawcę lub dokument przed zapisaniem szkicu.',
  'buy.needSupplierForInvoice': 'Wybierz dostawcę lub wpisz nazwę dostawcy przed zapisaniem płatności częściowej/faktury dostawcy.',
  'buy.draftSaved': 'Szkic zapisany.',
  'buy.attachmentUpdated': 'Dokument został zaktualizowany.',
  'buy.invoiceRegisteredOpen': 'Faktura zarejestrowana jako otwarta faktura dostawcy.',
  'buy.purchaseBooked': 'Zakup zaksięgowany! Dokument znajduje się teraz w Transakcjach.',
  'buy.purchaseSaveFailed': 'Nie udało się zapisać zakupu.',
  'buy.docsFetchedFromInbox': 'Dokumenty pobrane ze skrzynki odbiorczej: {count}',
  'buy.fullPayment': 'Pełna płatność',
  'buy.partPayment': 'Płatność częściowa',
  'buy.partPaymentWarning': 'Płatność częściowa jest rejestrowana jako faktura dostawcy. Pozostała kwota jest księgowana jako zobowiązanie wobec dostawcy na koncie 2400 do czasu zapłaty.',
  'buy.partPaymentLabel': 'Płatność częściowa {n}',
  'buy.remainingSuffix': '· pozostało',
  'buy.unpaidWillBeInvoice': 'Bez zarejestrowanej płatności zostanie to zapisane jako otwarta faktura dostawcy. Płatność możesz zarejestrować później.',
  'buy.forgotReceiptTitle': 'Zapomniałeś o dokumencie?',
  'buy.registerInvoice': 'Zarejestruj fakturę',
  'buy.bookPurchase': 'Zaksięguj zakup',
  'buy.registerInvoiceHelp': 'Zapisuje fakturę jako otwarte zobowiązanie wobec dostawcy. Pojawi się przy dostawcy, a płatność zarejestrujesz, gdy zostanie opłacona.',
  'buy.bookPurchaseHelp': 'Zapisuje zakup w księgach. Dokument trafia do „Transakcje”, a kwoty są księgowane na właściwych kontach.',
  'buy.typeBadgeInvoice': 'Faktura',
  'buy.typeBadgeAsset': 'Środek trwały',
  'buy.draftDeleteNotConnected': 'Usuwanie szkiców nie jest połączone z serwerem.',
  'buy.draftDeleted': 'Szkic usunięty.',
  'buy.draftDeleteFailed': 'Nie udało się usunąć szkicu.',
  'buy.pageHelpDrafts': 'Tutaj rejestrujesz wszystko, co kupuje firma. Wybierz „Szkice” z menu rozwijanego, aby zobaczyć rozpoczęte zakupy, których jeszcze nie zaksięgowałeś.',
  'buy.draftsPageHelp': 'Zakupy, które rozpocząłeś, ale nie dokończyłeś, są zapisywane tutaj. Otwórz szkic, aby kontynuować, lub usuń te, których nie potrzebujesz.',
  'buy.viewOptionsLabel': 'Opcje widoku',
  'buy.assetsLabel': 'Środki trwałe',
  'buy.noDraftsMatchSearch': 'Żaden szkic nie pasuje do wyszukiwania.',
  'buy.draftsEmptyHint': 'Tutaj pojawią się rozpoczęte zakupy zapisane jako szkice.',
  'buy.colSupplier': 'Dostawca',
  'buy.noSupplier': 'Bez dostawcy',
  'buy.colType': 'Typ',
  'buy.colInvoiceNo': 'Nr faktury',
  'buy.colDate': 'Data',
  'buy.colAmount': 'Kwota',
  'buy.thisPurchaseFallback': 'ten zakup',
  'buy.cannotBeUndone': '? Tej operacji nie można cofnąć.',
  'buy.formReset': 'Formularz został wyczyszczony',
  'buy.editPurchaseSubtitle': 'Zaktualizuj dokument i zapisz zmiany na serwerze.',
  'buy.newPurchasePageHelp': 'Tutaj rejestrujesz wszystko, co kupuje firma - towary, sprzęt, subskrypcje, podróże. Prześlij dokument, a SuperPlumma odczyta szczegóły i zaksięguje koszt na właściwym koncie z właściwym VAT.',
  'buy.defaultLineDescription': 'Zakup',
  'buy.customerFallback': 'Klient',
  'buy.supplierAndDateTitle': 'Dostawca i data',
  'buy.supplierAndDateInvoiceHelp': 'Od kogo kupiłeś i kiedy. Data faktury to data na fakturze, a termin płatności to dzień, do którego trzeba ją zapłacić. Numer faktury to własny numer dostawcy na fakturze.',
  'buy.supplierAndDatePurchaseHelp': 'Data zakupu decyduje, do którego okresu księgowego i VAT trafi zakup. Użyj daty z paragonu.',
  'buy.katFixedAssets': 'Środki trwałe / wyposażenie',
  'buy.katRent': 'Czynsz',
  'buy.katPhoneInternet': 'Telefon i internet',
  'buy.katSoftware': 'Oprogramowanie / subskrypcja',
  'buy.katTravel': 'Podróże i diety',
  'buy.katRepresentation': 'Reprezentacja',
  'buy.acct4000': 'Surowce i półprodukty',
  'buy.acct4300': 'Zakup towarów do odsprzedaży',
  'buy.acct4500': 'Usługi obce i podwykonawcy',
  'buy.acct5000': 'Wynagrodzenia pracowników',
  'buy.acct5400': 'Składka pracodawcy',
  'buy.acct5900': 'Prezenty dla pracowników',
  'buy.acct6000': 'Amortyzacja',
  'buy.acct6100': 'Koszty frachtu i transportu',
  'buy.acct6200': 'Energia, prąd i ogrzewanie',
  'buy.acct6300': 'Najem lokali',
  'buy.acct6320': 'Wywóz śmieci, woda, kanalizacja itp.',
  'buy.acct6340': 'Oświetlenie, ogrzewanie',
  'buy.acct6360': 'Sprzątanie',
  'buy.acct6400': 'Najem maszyn',
  'buy.acct6500': 'Narzędzia i wyposażenie',
  'buy.acct6540': 'Wyposażenie i sprzęt',
  'buy.acct6550': 'Materiały eksploatacyjne',
  'buy.acct6560': 'Artykuły drobne',
  'buy.acct6600': 'Naprawy i konserwacja budynków',
  'buy.acct6690': 'Naprawy i konserwacja – pozostałe',
  'buy.acct6700': 'Badanie sprawozdań i księgowość',
  'buy.acct6720': 'Pomoc prawna',
  'buy.acct6790': 'Pozostałe usługi obce',
  'buy.acct6800': 'Artykuły biurowe',
  'buy.acct6810': 'Koszty IT',
  'buy.acct6820': 'Druki',
  'buy.acct6900': 'Telefon',
  'buy.acct6940': 'Opłaty pocztowe',
  'buy.acct7000': 'Paliwo do pojazdów',
  'buy.acct7020': 'Utrzymanie samochodu',
  'buy.acct7040': 'Ubezpieczenie i opłaty za pojazdy',
  'buy.acct7100': 'Kilometrówka',
  'buy.acct7140': 'Koszty podróży niepodlegające zgłoszeniu',
  'buy.acct7150': 'Koszty diet',
  'buy.acct7160': 'Koszty podróży podlegające zgłoszeniu',
  'buy.acct7300': 'Koszty sprzedaży',
  'buy.acct7320': 'Reklama i ogłoszenia',
  'buy.acct7350': 'Reprezentacja – podlegająca odliczeniu',
  'buy.acct7360': 'Reprezentacja – niepodlegająca odliczeniu',
  'buy.acct7400': 'Składki członkowskie',
  'buy.acct7500': 'Składka ubezpieczeniowa',
  'buy.acct7600': 'Licencje, patenty i opłaty licencyjne',
  'buy.acct7700': 'Pozostałe koszty operacyjne',
  'buy.acct7770': 'Opłaty bankowe i kartowe',
  'buy.acct7790': 'Pozostałe koszty',
  'buy.acct8050': 'Przychody z odsetek',
  'buy.acct8150': 'Koszty odsetek',
  'buy.acct8300': 'Podatek należny',
  'buy.fallbackCostName': 'Koszt',
  'buy.fallbackAccountName': 'Konto',
  'buy.grp40': 'Koszt towarów',
  'buy.grp43': 'Towary do odsprzedaży',
  'buy.grp45': 'Zakup usług',
  'buy.grp50': 'Wynagrodzenia',
  'buy.grp54': 'Składka pracodawcy',
  'buy.grp59': 'Koszty personelu',
  'buy.grp60': 'Amortyzacja',
  'buy.grp61': 'Fracht i transport',
  'buy.grp62': 'Energia i ogrzewanie',
  'buy.grp63': 'Lokale',
  'buy.grp64': 'Najem maszyn i sprzętu',
  'buy.grp65': 'Narzędzia i wyposażenie',
  'buy.grp66': 'Naprawy i konserwacja',
  'buy.grp67': 'Usługi obce',
  'buy.grp68': 'Koszty biurowe',
  'buy.grp69': 'Telefon, poczta itp.',
  'buy.grp70': 'Środki transportu',
  'buy.grp71': 'Podróże i diety',
  'buy.grp73': 'Sprzedaż i reprezentacja',
  'buy.grp74': 'Składki członkowskie',
  'buy.grp75': 'Ubezpieczenia',
  'buy.grp76': 'Licencje i opłaty licencyjne',
  'buy.grp77': 'Pozostałe koszty operacyjne',
  'buy.grp15': 'Należności krótkoterminowe',
  'buy.grp24': 'Zobowiązania wobec dostawców',
  'buy.groupAssets': 'Aktywa',
  'buy.groupEquityAndLiabilities': 'Kapitał własny i zobowiązania',
  'buy.groupIncome': 'Przychody',
  'buy.groupCostOfGoods': 'Koszt towarów',
  'buy.groupPayrollAndPersonnel': 'Wynagrodzenia i koszty personelu',
  'buy.groupOtherOperating': 'Pozostałe koszty operacyjne',
  'buy.groupFinanceAndTax': 'Finanse i podatki',
  'buy.groupAccountsFallback': 'Konta',
  'rep.trial.onlyMovement': 'Pokaż tylko konta z obrotami',
  'rep.trial.showInactive': 'Pokaż także nieaktywne konta',
  'rep.trial.payrollLiability': 'Należne wynagrodzenia',
  'rep.trial.holidayPayLiability': 'Należny dodatek urlopowy',
  'rep.trial.oneEmployee': '{n} pracownik',
  'rep.trial.employeeCount': 'Pracownicy: {n}',
  'rep.trial.otherPayrollLiability': 'Wszystkie księgowania na koncie 2930',
  'rep.trial.allAccountEntries': 'Wszystkie księgowania na koncie {account}',
  'rep.trial.payrollRun': 'Lista płac {period}',
  'rep.trial.term': 'Okres {term} {year}',
  'rep.trial.accrualYear': 'Rok nabycia {year}',
  'vehiclePolicy.dialogTitle': 'Pojazd i koszty pojazdu',
  'vehiclePolicy.intro': 'Wybierz, jak Plumme ma traktować paliwo, warsztat i inne wyraźne koszty pojazdu. To ustawienie robocze dla propozycji dokumentów i nie rejestruje pojazdu jako aktywa.',
  'vehiclePolicy.optionVat': 'Pojazd z odliczeniem VAT',
  'vehiclePolicy.optionVatSub': 'Firma jest właścicielem lub leasingobiorcą pojazdu, typ pojazdu daje prawo do odliczenia, a koszt dotyczy zarejestrowanej działalności podlegającej VAT.',
  'vehiclePolicy.optionNoVat': 'Pojazd bez odliczenia VAT',
  'vehiclePolicy.optionNoVatSub': 'Proponuj koszt pojazdu bez odliczenia VAT naliczonego.',
  'vehiclePolicy.optionManual': 'Sprawdzaj każdy dokument ręcznie',
  'vehiclePolicy.optionManualSub': 'Plumme proponuje konto, ale pozostawia odliczenie VAT do sprawdzenia.',
  'vehiclePolicy.validFrom': 'Obowiązuje od',
  'vehiclePolicy.noEndDateWarning': 'Bez daty końcowej wybór obowiązuje, dopóki go nie zmienisz. Nowy wybór automatycznie kończy poprzedni od daty zmiany.',
  'vehiclePolicy.responsibility': 'Potwierdzam, że informacja jest prawidłowa, i rozumiem, że muszę ją sam(a) zaktualizować, jeśli pojazd zostanie sprzedany, umowa leasingu się zakończy albo zmieni się typ lub sposób użytkowania pojazdu.',
  'vehiclePolicy.receiptTitle': 'Określ pojazd raz',
  'vehiclePolicy.receiptText': 'Wtedy kolejne dokumenty za paliwo i warsztat automatycznie otrzymają właściwą propozycję VAT.',
  'vehiclePolicy.changeFromReceiptTitle': 'Zmienić regułę pojazdu?',
  'vehiclePolicy.changeFromReceiptText': 'Ustawiono 0 % odliczenia VAT dla tego dokumentu pojazdu. Czy ma to dotyczyć tylko tego dokumentu, czy Plumme ma od teraz traktować koszty pojazdu bez odliczenia VAT, ponieważ pojazd został sprzedany, leasing się zakończył lub prawo do odliczenia już nie przysługuje?',
  'vehiclePolicy.changeFromReceiptDate': 'Nowa reguła będzie obowiązywać od {date}.',
  'vehiclePolicy.receiptOnly': 'Tylko ten dokument',
  'vehiclePolicy.updateToNoVat': 'Stosuj 0 % od teraz',
  'vehiclePolicy.settingsTitle': 'Pojazd i koszty pojazdu',
  'vehiclePolicy.settingsText': 'Steruje automatycznymi propozycjami dla paliwa, warsztatu i innych wyraźnych kosztów pojazdu. Ustawienie niczego nie księguje i nie tworzy aktywa ani umowy leasingu.',
  'vehiclePolicy.choose': 'Wybierz ustawienie',
  'vehiclePolicy.change': 'Zmień ustawienie',
  'vehiclePolicy.save': 'Zapisz i zastosuj',
  'vehiclePolicy.saved': 'Ustawienie pojazdu zostało zapisane.',
  'vehiclePolicy.saveError': 'Nie udało się zapisać ustawienia pojazdu.',
  'vehiclePolicy.chooseError': 'Wybierz, jak mają być traktowane dokumenty pojazdu.',
  'vehiclePolicy.confirmError': 'Potwierdź, że firma sama będzie aktualizować tę informację.',
  'vehiclePolicy.notConfigured': 'Nie skonfigurowano – dokumenty pojazdu wymagają sprawdzenia',
  'vehiclePolicy.activeFrom': 'Obowiązuje od',
  'vehiclePolicy.noEndDate': 'brak daty końcowej',
  'vehiclePolicy.mode.vat_deductible': 'Pojazd z odliczeniem VAT',
  'vehiclePolicy.mode.no_vat_deduction': 'Pojazd bez odliczenia VAT',
  'vehiclePolicy.mode.manual_review': 'Ręczna kontrola każdego dokumentu',
  'buy.vatDeduction': 'Odliczenie VAT naliczonego',
  'buy.vatDeductionFull': '100 %',
  'buy.vatDeductionNone': '0 %',
  'buy.vatDeductionPartial': 'Częściowe',
  'buy.vatDeductionPercent': 'Procent odliczenia',
  'buy.fixedAssetLine': 'Zarejestruj pozycję jako środek trwały',
  'buy.fixedAssetLineHelp': 'Pozycja zostanie dodana do ewidencji środków trwałych zamiast być traktowana wyłącznie jako koszt.',
  'buy.fixedAssetFallback': 'Środek trwały',
  'buy.projectForLine': 'Projekt dla tej pozycji',
  'sup.credit.created': 'Faktura korygująca dostawcy została zaksięgowana.',
  'sup.credit.refunded': 'Zwrot został zaksięgowany.',
  'sup.credit.title': 'Zarejestruj fakturę korygującą dostawcy',
  'sup.credit.refundTitle': 'Zarejestruj zwrot z faktury korygującej',
  'sup.credit.action': 'Zaksięguj fakturę korygującą',
  'sup.credit.refundAction': 'Zarejestruj zwrot',
});
